module.exports = __webpack_public_path__ + "img/GoFoodie.4ec06d2e.png";